import { render, staticRenderFns } from "./JMavonEditor.vue?vue&type=template&id=a2bacb18&scoped=true"
import script from "./JMavonEditor.vue?vue&type=script&lang=js"
export * from "./JMavonEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bacb18",
  null
  
)

export default component.exports